import { registerLanguageDictionary, ruRU } from 'handsontable/i18n';
import { registerAllModules } from 'handsontable/registry';
import { initNumbro } from './initNumbro';

let initialized = false;

export function initHandsontable(): void {
  if (initialized) return;
  
  initNumbro();
  registerLanguageDictionary(ruRU);
  registerAllModules();
  
  initialized = true;
}

export function isHandsontableInitialized(): boolean {
  return initialized;
}